import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@assets/PurpleDragonflyLogo.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-2xl text-black " }, "Winner, 2017", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-center rounded-md" }, [
  /*#__PURE__*/_createVNode("img", {
    style: {"width":"131px","height":"131px"},
    class: "w-1/4 h-auto m-4 bg-white border-2 border-black rounded-md",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "Treasure's Gift is a 2017 winner of the", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, "Purple Dragonfly Award", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "for Best Children's Book in the Animal/Pet category.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_group = _resolveComponent("group")

  return (_openBlock(), _createBlock(_component_group, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }))
}